"use client";
import { Splide, SplideTrack } from "@splidejs/react-splide";
import { ChevronLeft, ChevronRight } from "lucide-react";
// Default theme
import "@splidejs/react-splide/css";
import React, { useState, useEffect, useRef, useCallback } from "react";
import useBreakpoint from "@/hooks/useBreakpoints";

import BannerTemplate from "./template";
import Link from "next/link";

export default function HomeBanner({ homePageBanner }) {
  const mobile = ["sm", "xs"];
  const splideRef = useRef(null); // Create a ref for Splide
  const breakpoint = useBreakpoint();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [progress, setProgress] = useState(0);
  const progressRef = useRef(0);
  const animationFrameRef = useRef(null);

  const options = {
    perPage: 1,
    pagination: false, // Disable default pagination
    arrows: breakpoint === "md", // Custom arrows
    autoplay: true,
    interval: 5000,
    pauseOnHover: true,
    resetProgress: false,
    type: "fade",
    rewind: true,
    drag: mobile.includes(breakpoint), // Disable dragging
    noDrag: ".splide__slide", // Prevent dragging on slide content
  };

  const goToSlide = (index) => {
    if (splideRef.current) {
      splideRef.current.splide.go(index); // Use Splide's go() method to change slide
    }
    setCurrentSlide(index); // Update state for current slide
  };

  const handlePrev = () => {
    if (splideRef.current) {
      splideRef.current.splide.go(currentSlide - 1); // Go to the previous slide
    }
  };

  const handleNext = () => {
    if (splideRef.current) {
      splideRef.current.splide.go(currentSlide + 1); // Go to the next slide
    }
  };

  const handleSlideChange = useCallback(() => {
    if (splideRef.current) {
      const splide = splideRef.current.splide;

      const handleAutoplayProgress = (rate) => {
        progressRef.current = rate * 100;

        if (animationFrameRef.current) {
          cancelAnimationFrame(animationFrameRef.current);
        }

        animationFrameRef.current = requestAnimationFrame(() => {
          setProgress(progressRef.current);
        });
      };

      splide.on("autoplay:playing", handleAutoplayProgress);

      return () => {
        splide.on("autoplay:playing", handleAutoplayProgress);
      };
    }
  }, []);

  useEffect(() => {
    const splide = splideRef?.current?.splide;
    if (splide) {
      const cleanup = handleSlideChange();
      splide.on("move", handleSlideChange); // Add event listener

      return () => {
        cleanup && cleanup();
        splide.off("move", handleSlideChange);
        if (animationFrameRef.current) {
          cancelAnimationFrame(animationFrameRef.current);
        }
      };
    }
  }, [handleSlideChange]);

  const handleMoved = (splide, newIndex) => {
    setCurrentSlide(newIndex);
  };

  return (
    <>
      <Splide
        aria-label="Home banner"
        options={options}
        ref={splideRef} // Attach the ref to Splide
        onMoved={handleMoved} // Track current slide
        hasTrack={false}
      >
        <div className="relative ">
          <SplideTrack>
            {homePageBanner &&
              homePageBanner["Home Banner"] &&
              [...homePageBanner["Home Banner"]].map((slide, index) => {
                return (
                  <BannerTemplate
                    key={index}
                    slide={slide}
                    theme={slide.theme}
                    variant={slide.textPosition}
                  />
                );
              })}
          </SplideTrack>
        </div>
      </Splide>

      {/* Mobile Navigation (Next/Previous) */}
      <div className="flex justify-end relative top-[-50px] mr-[10px] md:mr-[30px]">
        {/* <div
          className={`w-full h-[3px] rounded absolute left-0 top-[0px] bg-black`}
        >
          <div
            className="bg-system-primary h-[3px] rounded "
            style={{
              width: `${progress}%`,
            }}
          ></div>
        </div>

        <span className="slide-number text-system-disabled ">
          0{`${currentSlide + 1} `}
        </span> */}
        <div className="w-[76px] flex justify-between">
          <button onClick={handlePrev} className="prev-btn rounded-[5px] text-center flex justify-center items-center bg-[#FBFBFB] w-[30px] h-[30px]">
            <ChevronLeft
              className={` w-[18px] h-[18px] text-[#0F1938]`} // Hide icon with opacity
            />
          </button>

        

          <button onClick={handleNext} className="next-btn rounded-[5px] text-center flex justify-center items-center bg-[#FBFBFB] w-[30px] h-[30px]">
            <ChevronRight
              className={` h-[18px] w-[18px] `} // Hide icon with opacity
            />
          </button>
        </div>
      </div>

      {/* Custom pagination buttons with slide number in <span> and custom text */}
      {/* <div className="flex  custom-pagination   bg-system-disabled font-[17px]">
        {homePageBanner &&
          homePageBanner["Home Banner"] &&
          [...homePageBanner["Home Banner"]].map((slide, index) => {
            return (
              <div
                role="button"
                key={index}
                onClick={() => goToSlide(index)} // Change slide on button click
                className={`relative w-full p-4 text-[15px]  wireless-Regular xl:text-[1.04vw] border-r-[1px] border-system-grey ${
                  index === currentSlide ? "active bg-black text-white" : ""
                }`}
                aria-label={`Go to slide ${index + 1}`}
              >
                {index === currentSlide && (
                  <div
                    className={`w-full h-[2px] rounded absolute left-0 top-[0px] bg-black`}
                  >
                    <div
                      className="bg-system-primary h-[2px] rounded "
                      style={{
                        width: `${progress}%`,
                      }}
                    ></div>
                  </div>
                )}
                <span
                  className={`${
                    currentSlide === index
                      ? "text-white"
                      : "text-system-primary"
                  }  block mb-[9px] wireless-Regular`}
                >
                  0{`${index + 1}`}
                </span>{" "}
                {` ${slide.slideName}`}
              </div>
            );
          })}
      </div> */}
    </>
  );
}
